module.exports = __webpack_public_path__ + "static/media/logo.7632f13c.png";